/* eslint-disable no-bitwise */
/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
/* eslint-disable no-unused-vars */

const DdsCommand = {
  GETID1: {
    value: 0x01,
    text: 'GETID1',
  },
  GETID2: {
    value: 0x02,
    text: 'GETID2',
  },
  GETID_ACK: {
    value: 0x03,
    text: 'GETID_ACK',
  },
  GETDATA: {
    value: 0x04,
    text: 'GETDATA',
  },
  GETDATA_ACK: {
    value: 0x05,
    text: 'GETDATA_ACK',
  },
  SETBAUDRATE: {
    value: 0x06,
    text: 'SETBAUDRATE',
  },
  SETSUBADDRESS: {
    value: 0x07,
    text: 'SETSUBADDRESS',
  },
  GETEXTENDEDDATA: {
    value: 0x08,
    text: 'GETEXTENDEDDATA',
  },
  GETEXTENDEDDATA_ACK: {
    value: 0x09,
    text: 'GETEXTENDEDDATA_ACK',
  },
};

const DdsSensorAddress = {
  VBUS3_BROADCAST: {
    value: 0x2000,
    text: 'Broadcast',
  },
  GRUNDFOS_VFD_1TO20: {
    value: 0x2010,
    text: 'VFD 1-20',
  },
  GRUNDFOS_VFD_2TO40: {
    value: 0x2020,
    text: 'VFD 2-40',
  },
  GRUNDFOS_VFD_2TO40FAST: {
    value: 0x2030,
    text: 'VFD 2-40f',
  },
  GRUNDFOS_VFD_5TO100: {
    value: 0x2040,
    text: 'VFD 5-100',
  },
  GRUNDFOS_VFD_10TO200: {
    value: 0x2050,
    text: 'VFD 10-200',
  },
  GRUNDFOS_VFD_1TO12: {
    value: 0x2070,
    text: 'VFD 1-12',
  },
  GRUNDFOS_RPD_0TO10: {
    value: 0x2060,
    text: 'RPD',
  },
  RESOL_RHD: {
    value: 0x2140,
    text: 'RHD',
  },
  RESOL_RCS: {
    value: 0x2160,
    text: 'RCS',
  },
  RESOL_RADON: {
    value: 0x2170,
    text: 'Radon',
  },
  ALLENGRA_2TO40: {
    value: 0x2030,
    text: 'Allengra',
  },
};

const DdsSensorValueTypeTemperature = {
  typeName: 'Temperature',
  text: 'Temperatur',
  unit: '°C',
  factor: 100,
  valueType: 'number',
  conversion: 'rawTemperature',
  default: 0,
};

const DdsSensorValueTypeVolume = {
  typeName: 'Volume',
  text: 'Volumenstrom',
  unit: 'l/min',
  factor: 100,
  valueType: 'number',
  conversion: 'rawFlow',
  default: 0,
};

const DdsSensorValueTypeHumidity = {
  typeName: 'Humidity',
  text: 'rel.Luftfeuchte',
  unit: '%rH',
  factor: 100,
  valueType: 'number',
  conversion: 'rawHumidity',
  default: 0,
};

const DdsSensorValueTypePressure = {
  typeName: 'Pressure',
  text: 'Druck',
  unit: 'bar',
  factor: 100,
  valueType: 'number',
  conversion: 'rawPressure',
  default: 100,
};

const DdsSensorValueTypePercent = {
  typeName: 'Percent',
  text: 'Prozent',
  unit: '%',
  factor: 100,
  valueType: 'number',
  conversion: 'rawPercent',
  default: 0,
};

const DdsSensorValueTypeRadonConcentration = {
  typeName: 'Aktivitätskonzentration',
  text: 'Radonkonzentration',
  unit: 'Bq/m^3',
  factor: 1,
  valueType: 'number',
  conversion: 'rawRadonConcentration',
  default: 0,
};

const DdsSensorValueTypeIaq = {
  typeName: 'IAQ',
  text: 'IAQ',
  unit: '',
  factor: 100,
  valueType: 'number',
  conversion: 'rawIaq',
  default: 0,
};

const DdsSensorValueTypeRaw = {
  typeName: 'Raw',
  text: 'Rohwert',
  unit: '',
  factor: 1,
  valueType: 'number',
  conversion: 'raw',
  default: 0,
};


const DdsSensorTypes = {
  VFD_1_20: {
    typeName: 'VFD_1_20',
    address: DdsSensorAddress.GRUNDFOS_VFD_1TO20.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_1TO20.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  VFD_2_40: {
    typeName: 'VFD2_40',
    address: DdsSensorAddress.GRUNDFOS_VFD_2TO40.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_2TO40.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  VFD_2_40F: {
    typeName: 'VFD2_40F',
    address: DdsSensorAddress.GRUNDFOS_VFD_2TO40FAST.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_2TO40FAST.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  VFD_5_100F: {
    typeName: 'VFD5_100',
    address: DdsSensorAddress.GRUNDFOS_VFD_5TO100.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_5TO100.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  VFD_10_200F: {
    typeName: 'VFD10_200',
    address: DdsSensorAddress.GRUNDFOS_VFD_10TO200.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_10TO200.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  VFD_1_12: {
    typeName: 'VFD1_12',
    address: DdsSensorAddress.GRUNDFOS_VFD_1TO12.value,
    text: DdsSensorAddress.GRUNDFOS_VFD_1TO12.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
  RPD: {
    typeName: 'RPD',
    address: DdsSensorAddress.GRUNDFOS_RPD_0TO10.value,
    text: DdsSensorAddress.GRUNDFOS_RPD_0TO10.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypePressure,
      },
    ],
  },
  RHD: {
    typeName: 'RHD',
    address: DdsSensorAddress.RESOL_RHD.value,
    text: DdsSensorAddress.RESOL_RHD.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeHumidity,
      },
    ],
  },
  RADON: {
    typeName: 'Radon',
    address: DdsSensorAddress.RESOL_RADON.value,
    text: DdsSensorAddress.RESOL_RADON.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeHumidity,
      },
      {
        byteIndex: 4,
        byteSize: 2,
        type: DdsSensorValueTypeRadonConcentration,
      },
      {
        byteIndex: 6,
        byteSize: 1,
        type: DdsSensorValueTypeRaw,
        text: 'Info',
      },
    ],
  },
  RCS: {
    typeName: 'RCS',
    address: DdsSensorAddress.RESOL_RCS.value,
    text: DdsSensorAddress.RESOL_RCS.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeHumidity,
      },
      {
        byteIndex: 4,
        byteSize: 2,
        type: DdsSensorValueTypePercent,
      },
      {
        byteIndex: 6,
        byteSize: 1,
        type: DdsSensorValueTypeRaw,
        text: 'Modus',
      },
      {
        byteIndex: 7,
        byteSize: 2,
        type: DdsSensorValueTypePressure,
      },
      {
        byteIndex: 9,
        byteSize: 2,
        type: DdsSensorValueTypeIaq,
      },
      {
        byteIndex: 11,
        byteSize: 2,
        type: DdsSensorValueTypeRaw,
        text: 'Bestückungsvariante',
      },
      {
        byteIndex: 13,
        byteSize: 1,
        type: DdsSensorValueTypeRaw,
        text: 'Sensorstatus',
      },
    ],
  },
  Allengra: {
    typeName: 'Allengra',
    address: DdsSensorAddress.ALLENGRA_2TO40.value,
    text: DdsSensorAddress.ALLENGRA_2TO40.text,
    fields: [
      {
        byteIndex: 0,
        byteSize: 2,
        type: DdsSensorValueTypeTemperature,
      },
      {
        byteIndex: 2,
        byteSize: 2,
        type: DdsSensorValueTypeVolume,
      },
    ],
  },
};

function getDdsFieldValues(ddsType, buffer) {
  let byteIndex = 0;
  const fieldValues = [];
  for (let i = 0; i < ddsType.fields.length; i += 1) {
    let rawValue = -1;
    const field = ddsType.fields[i];
    switch (field.byteSize) {
      case 1:
        rawValue = buffer.readUInt8(byteIndex);
        break;
      case 2:
        rawValue = buffer.readInt16LE(byteIndex);
        break;
      case 4:
        rawValue = buffer.readInt32LE(byteIndex);
        break;
      default:
        break;
    }
    byteIndex += field.byteSize;
    if (field.type.displayExponent) {
      rawValue *= (10 ** field.type.displayExponent);
      if (field.type.displayExponent < 0) {
        rawValue = rawValue.toFixed(Math.abs(field.type.displayExponent));
      }
    }
    const valueString = `${rawValue} ${field.type.unit}`;

    let typeName = field.text;
    if (!typeName) {
      typeName = field.type.text;
    }

    fieldValues.push({
      raw: rawValue,
      text: valueString,
      typeName,
    });
  }

  return fieldValues;
}

function getDdsSensorByTelegram(telegram) {
  const sensorType = Object.values(DdsSensorTypes).find(
    x => x.address === (telegram.sourceAddress  & 0xFFF0),
  );
  const fieldValues = [];
  if (sensorType) {
    sensorType.subAddress = telegram.sourceAddress & 0x000F;
    const telegramFieldValues = getDdsFieldValues(sensorType, telegram.frameData);
    if (telegramFieldValues) {
      fieldValues.push(...telegramFieldValues);
    }
  }
  return {
    type: sensorType,
    fieldValues,
  };
}

function getDdsCommandByTelegram(telegram) {
  return Object.values(DdsCommand).find(
    x => x.value === (telegram.command & 0x1F),
  );
}

module.exports = {
  DdsCommand,
  DdsSensorAddress,
  DdsSensorTypes,
  getDdsCommandByTelegram,
  getDdsSensorByTelegram,
};
